// Extracts YouTube video ID from the given URL
export const getYtVideoId = (url) => {
    let match = url.match(/youtu\.be\/(.{11})/);
    if (match) return match[1];
    match = url.match(/youtube\.com\/watch\?v=(.{11})/);
    if (match) return match[1];
};
